import { ImportCsvRequest, ImportCsvResponse, SuccessResponse, WashingMachinePart } from '@/types'
import { CreateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/CreateWashingMachinePartRequest'
import { GetWashingMachinePartRequest } from '@/types/apis/washingMachinePart/GetWashingMachinePartRequest'
import { GetWashingMachinePartResponse } from '@/types/apis/washingMachinePart/GetWashingMachinePartResponse'
import { UpdateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/UpdateWashingMachinePartRequest'

import axios from './axios'

const API_ENDPOINT = '/washing-machine-part'

export const getAllWashingMachinePartApi = (): Promise<GetWashingMachinePartResponse> => {
  return axios.get(API_ENDPOINT)
}

export const getWashingMachinePartApi = (request: GetWashingMachinePartRequest): Promise<WashingMachinePart> => {
  return axios.get(`${API_ENDPOINT}/${request.id}`)
}

export const createWashingMachinePartApi = (request: CreateWashingMachinePartRequest): Promise<SuccessResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateWashingMachinePartApi = (request: UpdateWashingMachinePartRequest): Promise<SuccessResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteWashingMachinePartApi = (request: GetWashingMachinePartRequest): Promise<SuccessResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importCsvWashingMachinePartApi = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}
